import '../style/loading-B5P__l27.css'
import { defineComponent as c, useModel as d, useSlots as m, computed as l, openBlock as p, createElementBlock as h, normalizeClass as f, normalizeStyle as g, withDirectives as v, createVNode as _, unref as n, normalizeProps as y, guardReactiveProps as S, vShow as V, renderSlot as k, createCommentVNode as z } from "vue";
import B from "./spinner.js";
const P = /* @__PURE__ */ c({
  name: "e-loading",
  __name: "loading",
  props: {
    modelValue: { type: Boolean },
    height: {},
    center: { type: Boolean },
    spinner: { default: () => ({
      size: 50,
      strokeWidth: 4
    }) }
  },
  setup(s) {
    const t = s, o = d(t, "modelValue"), a = m(), r = l(() => !o.value && !!a.default), i = l(() => {
      const e = {};
      return o.value && t.height && (e.height = t.height), e;
    }), u = l(() => ({
      "e-loading__pending": o.value,
      "e-loading__center": t.center
    }));
    return (e, w) => (p(), h("div", {
      class: f(["e-loading", u.value]),
      style: g(i.value)
    }, [
      v(_(n(B), y(S(e.spinner)), null, 16), [
        [V, n(o)]
      ]),
      r.value ? k(e.$slots, "default", { key: 0 }) : z("", !0)
    ], 6));
  }
});
export {
  P as default
};
//# sourceMappingURL=loading.js.map
